import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { cn } from '@/utils/cn';
import { IntegrationsBackLink } from '@/pages/settings/ClinicIntegrations';

export function SmsSettingsLayout() {
  const { t } = useTranslation();

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      'whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition',
      isActive
        ? 'border-indigo-500 text-indigo-600 dark:border-indigo-400 dark:text-indigo-300'
        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-gray-600 dark:hover:text-gray-300',
    );

  return (
    <div className="space-y-6">
      <IntegrationsBackLink />

      <div>
        <div className="flex items-center gap-2">
          <MessageSquare className="h-5 w-5 text-indigo-500" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {t('settings.integrations.cards.sms_title')}
          </h2>
        </div>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {t('settings.integrations.cards.sms_description')}
        </p>
      </div>

      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-8" aria-label={t('settings.integrations.sms_tabs_label')}>
          <NavLink to="/settings/sms" end className={tabClass}>
            {t('settings.integrations.sms_tabs.overview')}
          </NavLink>
          <NavLink to="/settings/sms/automation" className={tabClass}>
            {t('settings.integrations.sms_tabs.automation')}
          </NavLink>
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
